import { $query } from "@/global-install";

const theme = `background: purple; color: white; padding: 2px`;

const isDev = process.env.NODE_ENV !== 'production';

const active = isDev || !!$query?.log;

const log = (tag, msg) => active && console && console.log(`%c${tag}`, theme, msg);

export default log;